import React, { useEffect, useState } from 'react';
import { PaperclipIcon } from 'src/assets/Images';
import { useMentionInput } from './hooks/useMentionInput';
import { Footer, Input, Actions, Button, IconButton, Icon, HiddenFileInput, FileListWrapper, FileListContainer, FileItem, FileInfo, FilePreviewImage, FileName, FileSize, RemoveFileButton, ErrorMessage, MentionList, MentionItem, MentionItemMeta, InputWrapper, InputOverlay, } from './styles';
export var ConversationInput = function (_a) {
    var text = _a.text, onTextChange = _a.onTextChange, onSend = _a.onSend, files = _a.files, filePreviews = _a.filePreviews, fileInputRef = _a.fileInputRef, handleFileSelect = _a.handleFileSelect, handleAttachClick = _a.handleAttachClick, handleRemoveFile = _a.handleRemoveFile, formatFileSize = _a.formatFileSize, _b = _a.isLoading, isLoading = _b === void 0 ? false : _b, _c = _a.disabled, disabled = _c === void 0 ? false : _c, extraActions = _a.extraActions, _d = _a.footerLayout, footerLayout = _d === void 0 ? 'flex' : _d, _e = _a.mentionableUsers, mentionableUsers = _e === void 0 ? [] : _e, onMentionedAdminUserIdsChange = _a.onMentionedAdminUserIdsChange;
    var _f = useState(false), showError = _f[0], setShowError = _f[1];
    var _g = useState(false), isFadingOut = _g[0], setIsFadingOut = _g[1];
    var _h = useMentionInput({
        text: text,
        onTextChange: onTextChange,
        mentionableUsers: mentionableUsers,
        onMentionedAdminUserIdsChange: onMentionedAdminUserIdsChange,
    }), wrapperRef = _h.wrapperRef, textareaRef = _h.textareaRef, overlayRef = _h.overlayRef, mentionListRef = _h.mentionListRef, mentionStart = _h.mentionStart, selectedMentionIndex = _h.selectedMentionIndex, filteredMentionableUsers = _h.filteredMentionableUsers, renderOverlayText = _h.renderOverlayText, closeMentionDropdown = _h.closeMentionDropdown, handleTextInputChange = _h.handleTextInputChange, selectMention = _h.selectMention, handleKeyDown = _h.handleKeyDown, handleInputScroll = _h.handleInputScroll, handleInputClick = _h.handleInputClick;
    var hasContent = text.trim() || files.length > 0;
    var hideErrorWithFade = function () {
        setIsFadingOut(true);
        setTimeout(function () {
            setShowError(false);
            setIsFadingOut(false);
        }, 300);
    };
    // Ocultar error cuando el usuario empieza a escribir o agregar archivos
    useEffect(function () {
        if (hasContent && showError) {
            hideErrorWithFade();
        }
    }, [hasContent, showError]);
    // Ocultar error automáticamente después de 5 segundos con fade out
    useEffect(function () {
        if (showError) {
            var timer_1 = setTimeout(function () {
                hideErrorWithFade();
            }, 5000);
            return function () { return clearTimeout(timer_1); };
        }
    }, [showError]);
    var handleSendClick = function () {
        if (disabled)
            return;
        if (!text.trim() && files.length === 0) {
            setShowError(true);
            setIsFadingOut(false);
            return;
        }
        if (showError) {
            hideErrorWithFade();
        }
        closeMentionDropdown();
        onSend();
    };
    var handleInputKeyDown = function (event) {
        var mentionHandled = handleKeyDown(event);
        if (mentionHandled)
            return;
        if (event.key === 'Enter' && !event.shiftKey) {
            event.preventDefault();
            handleSendClick();
        }
    };
    return (React.createElement("div", null,
        filePreviews.length > 0 && (React.createElement(FileListWrapper, null,
            React.createElement(FileListContainer, null, filePreviews.map(function (filePreview, index) { return (React.createElement(FileItem, { key: index },
                filePreview.preview && (React.createElement(FilePreviewImage, { src: filePreview.preview, alt: filePreview.file.name })),
                React.createElement(FileInfo, null,
                    React.createElement(FileName, null, filePreview.file.name),
                    React.createElement(FileSize, null,
                        "(",
                        formatFileSize(filePreview.file.size),
                        ")")),
                React.createElement(RemoveFileButton, { type: "button", onClick: function () { return handleRemoveFile(index); }, "aria-label": "Eliminar archivo", title: "Eliminar" }, "\u00D7"))); })))),
        React.createElement("div", { ref: wrapperRef },
            React.createElement(Footer, { layout: footerLayout },
                React.createElement(InputWrapper, null,
                    React.createElement(InputOverlay, { ref: overlayRef }, renderOverlayText),
                    React.createElement(Input, { ref: textareaRef, placeholder: disabled ? "" : "Escribí tu comentario...", value: text, onChange: function (e) { return handleTextInputChange(e.target.value, e.target.selectionStart); }, onKeyDown: handleInputKeyDown, onScroll: handleInputScroll, onClick: handleInputClick, disabled: disabled, style: {
                            borderColor: showError ? '#EF4444' : undefined,
                            opacity: disabled ? 0.6 : 1,
                            cursor: disabled ? 'not-allowed' : 'text',
                        } })),
                filteredMentionableUsers.length > 0 && mentionStart !== null && (React.createElement(MentionList, { ref: mentionListRef }, filteredMentionableUsers.map(function (user, index) { return (React.createElement(MentionItem, { key: user.id, "data-mention-option-index": index, isSelected: index === selectedMentionIndex, onMouseDown: function (event) {
                        event.preventDefault();
                        selectMention(user);
                    } },
                    "@",
                    user.fullName,
                    user.mentionType === 'client' && (React.createElement(MentionItemMeta, null, "Cliente")))); }))),
                React.createElement(Actions, null,
                    React.createElement(HiddenFileInput, { ref: fileInputRef, type: "file", accept: "application/pdf,image/jpeg,image/jpg,image/png", multiple: true, onChange: handleFileSelect }),
                    React.createElement(IconButton, { type: "button", "aria-label": "Adjuntar", title: "Adjuntar", onClick: handleAttachClick, disabled: disabled, style: {
                            borderColor: showError ? '#EF4444' : undefined,
                            opacity: disabled ? 0.6 : 1,
                            cursor: disabled ? 'not-allowed' : 'pointer',
                            pointerEvents: disabled ? 'none' : 'auto',
                        } },
                        React.createElement(Icon, { src: PaperclipIcon, alt: "Adjuntar" })),
                    React.createElement(Button, { type: "button", onClick: handleSendClick, disabled: isLoading || disabled, style: {
                            opacity: disabled ? 0.6 : (hasContent ? 1 : 0.6),
                            cursor: (isLoading || disabled) ? 'not-allowed' : 'pointer',
                            pointerEvents: (isLoading || disabled) ? 'none' : 'auto',
                        } }, "Enviar"),
                    extraActions)),
            showError && (React.createElement(ErrorMessage, { isFadingOut: isFadingOut }, "Debes escribir un comentario o adjuntar un archivo para enviar")))));
};
